import React, { Component } from "react";
import { Form, Row, Col, Modal } from "antd";
import { RightOutlined } from "@ant-design/icons";

import { BottomButton } from "./bottom-button/bottom-button";
import { submit, userConvert } from "./user-account-event";
import { apiUser } from "../../../api/api-users";
import { alert } from "../../../common/utils/alert";
import { AccountInfo } from "./account-info/account-info";
import { AccountStatus } from "./account-status/account-status";
import { AccountRange } from "./account-range/account-range";
import { AccountId } from "./account-id/account-id";

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};
//Sử dụng Ref cho vấn đề cập nhật lại UI trong các Component con
export class AddUserAccount extends Component {
  state = {
    editable: true,
    editPage: false,
    typeOption: "create_new",
    carStatusType: "CDD",
    inactiveDelete: false,
  };

  userParam = [];

  async componentDidMount() {
    const userOptions = await apiUser.getCreateUserOptions();
    if (userOptions.status === "success") {
      this.accountRange.setState({
        branches: userOptions.data.branches.map((item) => {
          return { ...item, name: item.code };
        }),
      });
      if (this.state.typeOption === "create_new") {
        this.form.setFieldsValue({
          signup_name: userOptions.data.code,
        });
      }
    }
  }

  submit = async () => {
    submit(this);
  };

  onChangeForm = (feild, value) => {
    this.form &&
      this.form.setFieldsValue({
        [feild]: value,
      });
  };
  // setCarStatusType = carStatusType => {
  //     this.setState({ carStatusType })
  // }

  onChangeFormValues = (values) => {
    this.form.setFieldsValue({
      ...values,
    });
  };

  goToUserDetail = () => {
    if (this.userParam) this.updateFormUser(this.userParam);
  };

  updateFormUser = (user) => {
    this.userParam = user;
    this.setState({
      editable: false,
      typeOption: "show_detail",
      editPage: true,
      userIdEdit: user.id,
    });
    userConvert(user, this);
  };

  enableEdit = () => {
    this.setState({ editable: true, typeOption: "edit" });
  };

  cancelEdit = () => {
    this.setState({ editable: false, typeOption: "show_detail" });
  };

  checkEditPass = (v) => {
    if (!this.state.checkEditPass) {
      this.setState({ checkEditPass: true });
      this.form.setFieldsValue({
        password: "",
      });
    } else {
      this.form.setFieldsValue({
        password: v,
      });
    }
  };

  render() {
    const { typeOption, editable, editPage } = this.state;
    return (
      <div className="add-user-account">
        <div className="add-new-user-title">
          <span onClick={this.props.close}>
            Tài khoản người dùng
            <RightOutlined style={{ margin: "0px 7px" }} />
          </span>
          {typeOption === "create_new"
            ? "Thêm tài khoản mới"
            : typeOption === "show_detail"
            ? "Chi tiết thông tin tài khoản"
            : "Chỉnh sửa thông tin tài khoản"}
        </div>
        <Form
          style={{ padding: "0px 10px" }}
          initialValues={{
            password: "Cus-0000",
            user_status: 0,
            permission_area: 1,
            department: null,
          }}
          scrollToFirstError
          ref={(ref) => (this.form = ref)}
          {...layout}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12} className="account-info">
              <AccountInfo
                editable={editable}
                editPage={false}
                onChangeForm={this.onChangeForm}
                ref={(ref) => (this.accountInfo = ref)}
                checkEditPass={this.checkEditPass}
                typeOption={typeOption}
              />
              <AccountStatus typeOption={typeOption} editable={editable} />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <AccountId
                editable={editable}
                editPage={editPage}
                onChangeForm={this.onChangeForm}
                ref={(ref) => (this.accountId = ref)}
                checkEditPass={this.checkEditPass}
                typeOption={typeOption}
              />
              <AccountRange
                ref={(ref) => (this.accountRange = ref)}
                typeOption={typeOption}
                editable={editable}
              />
            </Col>
          </Row>
        </Form>
        <BottomButton
          typeOption={typeOption}
          enableEdit={this.enableEdit}
          submit={this.submit}
          cancelEdit={this.cancelEdit}
          close={this.props.close}
          goToDetailUser={this.goToDetailUser}
          accountParam={this.userParam}
        />
      </div>
    );
  }
}
